/**
 * @passport/fake-auth
 *
 * DEBUG ONLY — shared constants for a local "Fake Login" bypass, usable by
 * any BizFirst app that wants one instead of each app hand-rolling its own.
 * Not a real auth mechanism; writes a hardcoded user/token directly into
 * @passport/store, bypassing the real login API entirely.
 *
 * Consuming apps: call `useAuthStore().setUser(FAKE_USER)` +
 * `setToken(FAKE_TOKEN_PREFIX + Date.now())` from a debug-only UI affordance.
 * Then, in your session-bootstrap check (wherever you call
 * @passport/store's `verifyToken()` on app load), skip that call when
 * `token?.startsWith(FAKE_TOKEN_PREFIX)` — a fake token can never pass real
 * backend verification, so calling verifyToken() on it will (correctly)
 * flip `isAuthenticated` to false while leaving `user` untouched, which
 * desyncs any UI that checks `isAuthenticated` (e.g.
 * @bizfirst/common-auth-react's AuthHeaderControls) from UI that checks
 * `user` (e.g. a router's logged-in guard).
 *
 * `FAKE_USER`'s shape matches @passport/store's `User` type exactly (id,
 * email, name, roles, permissions) — verified against
 * src/passport/packages/@passport/store/src/authStore.ts.
 */

export const FAKE_TOKEN_PREFIX = 'fake-debug-token-';

export interface FakeUser {
  id: string;
  email: string;
  name: string;
  roles: string[];
  permissions: string[];
}

export const FAKE_USER: FakeUser = {
  id: '1',
  email: 'fake.user@bizfirstai.com',
  name: 'Fake User',
  roles: ['IsDeveloper'],
  permissions: [],
};
